import React, { PureComponent, Fragment } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import { withTranslation } from 'react-i18next';

import SwabRequestForm from '../forms/SwabRequestForm';
import CenterModal from '../modal/CenterModal';

import './ContactSales.module.css';

const SwabRequest = DisplayComponent(
  class SwabRequest extends PureComponent {
    state = {
      open: false
    };

    handleLinkClick = e => {
      e.preventDefault();
      this.setState({
        open: true
      });
    };
    handleClose = () => {
      this.setState({
        open: false
      });
    };

    render() {
      const {
        linkText,
        classes,
        displayType,
        buttonColor,
        path,
        datasheets,
        t
      } = this.props;
      const { open } = this.state;
      return (
        <Fragment>
          {displayType === 'link' && (
            <button
              className={classes}
              styleName="link"
              onClick={this.handleLinkClick}
              onKeyUp={this.handleLinkClick}
              tabIndex="0"
            >
              {linkText}
            </button>
          )}
          {displayType === 'button' && (
            <Button
              className={classes}
              to="#"
              color={buttonColor}
              onClick={e => this.handleLinkClick(e)}
            >
              {linkText}
            </Button>
          )}
          {open ? (
            <CenterModal
              id="contact-sales"
              onClose={this.handleClose}
              width="1200px"
            >
              <SwabRequestForm
                path={path}
                onClose={() => this.handleClose()}
                title={t('Contact Us to Order Test Swabs')}
                buttonText={t('Request Swabs')}
              />
            </CenterModal>
          ) : null}
        </Fragment>
      );
    }
  }
);
export default withTranslation()(SwabRequest);
